module.exports = __webpack_public_path__ + "img/8.e6fe4540.jpg";